import { render } from "./main-side-bar.vue?vue&type=template&id=bcdafa52&scoped=true"
import script from "./main-side-bar.vue?vue&type=script&lang=js"
export * from "./main-side-bar.vue?vue&type=script&lang=js"

import "./main-side-bar.vue?vue&type=style&index=0&id=bcdafa52&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcdafa52"]])

export default __exports__